export const MY_COFFEES_DB_NAME = 'my-coffees';
export const MY_COFFEES_PAGE_SIZE = 20;
export const MY_COFFEES_QUICK_SEARCH_SIZE = 10;
